import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Stack from '@mui/material/Stack';
import type { TextFieldProps } from '@mui/material/TextField';

import IntervalTextInput from '../Inputs/IntervalTextInput';
import { type AllRepeatDetails, Weekday } from '../Repeat.types';
import { weekdayShortTextMapping } from '../utils';

interface RepeatWeeklyProps {
  value: AllRepeatDetails;
  onChange: (value: AllRepeatDetails) => void;
  inputSize: TextFieldProps['size'];
  inputVariant: TextFieldProps['variant'];
}

const RepeatWeekly = ({ value, onChange, inputSize, inputVariant }: RepeatWeeklyProps) => (
  <Stack spacing={2} sx={{ alignItems: 'flex-start' }}>
    <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
      <IntervalTextInput
        value={value}
        onChange={onChange}
        unit="week"
        pluralizeUnit
        inputSize={inputSize}
        inputVariant={inputVariant}
      />
    </Stack>
    <ButtonGroup variant="contained" sx={{ width: '100%' }}>
      {/* TODO - do this type/iteration better */}
      {Object.keys(Weekday).map((day) => {
        const dayKey = day as Weekday;
        return (
          <Button
            sx={{ width: '100%' }}
            key={dayKey}
            color={value?.byDay?.includes(dayKey) ? 'primary' : 'inherit'}
            onClick={() => {
              let selectedDays = value?.byDay || [];
              if (value?.byDay?.includes(dayKey)) {
                selectedDays = value?.byDay.filter((d) => d !== dayKey);
              } else {
                selectedDays = [...selectedDays, dayKey];
              }
              onChange({
                ...value,
                byDay: selectedDays,
              });
            }}
          >
            {weekdayShortTextMapping[dayKey]}
          </Button>
        );
      })}
    </ButtonGroup>
  </Stack>
);
export default RepeatWeekly;
